// extracted by mini-css-extract-plugin
export default {"main":"f66e55085e a5d90d6f0e _66da2e48f0 _6c0a9affe0","title":"_9013993179"};